import type { QmsTag } from '../../types/qmsCategoryTypes';

export const ALLOWED_LIMITS = [10, 30, 50, 100] as const;

export function isValidStatus(status: string): boolean {
  return ['active', 'inactive'].includes(status);
}

export function validateStatusString(statusStr: string): boolean {
  if (!statusStr) {
    return true;
  }
  return statusStr.split(',').every((s) => isValidStatus(s.trim()));
}

export function sanitizeStatusString(
  statusStr: string | null | undefined
): string | undefined {
  if (!statusStr) {
    return undefined;
  }
  const trimmed = String(statusStr).trim();
  if (!trimmed) {
    return undefined;
  }
  const valid = trimmed
    .split(',')
    .map((s) => s.trim())
    .filter((s) => s && isValidStatus(s));
  return valid.length > 0 ? valid.join(',') : undefined;
}

const dateFormatter = new Intl.DateTimeFormat('pl-PL', {
  timeZone: 'Europe/Warsaw',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
});

export function formatQmsCategoryCreatedAt(dateStr: string): string {
  const parts = dateFormatter.formatToParts(new Date(dateStr));
  const get = (type: string) => parts.find((p) => p.type === type)?.value ?? '';
  return `${get('year')}/${get('month')}/${get('day')}, ${get('hour')}:${get('minute')}:${get('second')}`;
}

export type FormattedQmsCategory = {
  id: string;
  name: string;
  description: string;
  tags: QmsTag[];
  status: 'active' | 'inactive';
  createdAt: string;
  formattedCreatedAt: string;
};
